<div class="login-container">
  <div class="login-card">
    <div class="login-header">
      <h1>PDV - Sistema de Vendas</h1>
      <p>Faça login para continuar</p>
    </div>

    <form [formGroup]="loginForm" (ngSubmit)="onSubmit()" class="login-form">

      <div class="form-group">
        <label for="login">Usuário:</label>
        <input
          type="text"
          id="login"
          formControlName="login"
          class="form-control"
          placeholder="Digite seu usuário"
          [ngClass]="{ 'is-invalid': submitted && f['login'].errors }"
          autocomplete="username"
        />
        <div *ngIf="submitted && f['login'].errors" class="error-message">
          <div *ngIf="f['login'].errors['required']">Usuário é obrigatório</div>
        </div>
      </div>

      <div class="form-group">
        <label for="password">Senha:</label>
        <input
          type="password"
          id="password"
          formControlName="password"
          class="form-control"
          placeholder="Digite sua senha"
          [ngClass]="{ 'is-invalid': submitted && f['password'].errors }"
          autocomplete="current-password"
        />
        <div *ngIf="submitted && f['password'].errors" class="error-message">
          <div *ngIf="f['password'].errors['required']">Senha é obrigatória</div>
        </div>
      </div>

      <button
        type="submit"
        class="btn-login"
        [disabled]="loading || loginForm.invalid"
      >
        <span *ngIf="!loading">Entrar</span>
        <span *ngIf="loading">Autenticando...</span>
      </button>
    </form>
  </div>
</div>

<p-toast></p-toast>

